<template>
  <div class="success">
    <div class="info">
      <van-icon name="checked" />
      <div class="tab">订单已经提交</div>
      <div class="text">请等待机构确认</div>
    </div>
    <div class="back" @click="backTap">返回（{{second}}）</div>
  </div>
</template>
<script>
var timer
export default {
  data() {
    return {
      second: 5
    }
  },
  mounted() {
    timer = setInterval(() => {
      this.second--
      if (this.second <= 0) {
        this.backTap()
      }
    }, 1000)
  },
  methods: {
    backTap() {
      clearInterval(timer)
      this.$router.go(-3)
    }
  }
}
</script>
<style lang="scss" scoped>
.success{
    width:100%;
    min-height:100vh;
    background:#f7f7f7;
    .info{
        background:#fff;
        padding:44px 0 30px;
        text-align:center;
        .van-icon{
            font-size:56px;
            color:#1AD690;
        }
        .tab{
           font-size:18px;
           margin-top:16px;
           font-weight:bold;
        }
        .text{
            font-size:14px;
            color:#999;
            margin-top:10px;
        }
    }
    .back{
        width:100%;
        padding:10px 0;
        text-align:center;
        background:#fff;
        margin-top:15px;
        font-size:16px;
        color:#0080FF;
    }
}
</style>
